<template>
    <manage-password title="User Profile" />
</template>

<script>
import ManagePassword from '../../components/ManagePassword.vue'
export default {
    components: { ManagePassword },
    name: 'CustomerProfile',
}
</script>